<template>
    <vx-expandable-card>
        <template v-slot:header> To </template>
        <template v-slot:content>
            <div class="max-w-full">
                <div class="mb-4">
                    <span class="text-slate-900 font-semibold text-sm block sm:text-base">
                        Segments to receive this message
                    </span>
                    <span class="text-slate-500 text-xs">
                        Segments filtered to match the audience type <strong>{{ props.campaignType }}</strong> that you
                        chose on the previous step.
                    </span>
                </div>

                <segments-selectable size="lg" :audience-type="props.campaignType" v-model="segments">
                </segments-selectable>
                <div class="text-xs text-slate-500 font-normal mt-4 flex items-center">
                    <font-awesome-icon
                        widthAuto
                        :icon="faCircleInfo"
                        class="text-gray text-sm mr-1"
                    ></font-awesome-icon>
                    <span class="flex flex-col items-start sm:block">
                        To edit or create segments, visit the&nbsp;
                        <span>
                            <a href="/contacts/segments" target="_blank" class="text-inherit underline">segments page</a
                            >.
                        </span>
                    </span>
                </div>

                <vx-alert v-if="validate.ids.$errors.length" class="my-3" :closeable="false" color="danger">{{
                    displayFirstError(validate.ids.$errors)
                }}</vx-alert>
            </div>
        </template>
    </vx-expandable-card>
</template>

<script setup>
import { VxAlert, VxExpandableCard } from '@voxie/frontend-components';
import { computed, watch } from 'vue';
import SegmentsSelectable from '~/components/general/segments/SegmentsSelectable.vue';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import { faCircleInfo } from '@fortawesome/pro-solid-svg-icons';
import { AUDIENCE_TYPE_MARKETING, AUDIENCE_TYPE_TRANSACTIONAL, MAX_SEGMENTS_PER_CAMPAIGN } from '~/constants/campaign';
import useVuelidate from '@vuelidate/core';
import { displayFirstError } from '~/utils/validation';
import { helpers, maxLength, required } from '@vuelidate/validators';

const props = defineProps({
    campaignType: {
        type: String,
        default: undefined,
        validator: (campaignType) =>
            [AUDIENCE_TYPE_MARKETING, AUDIENCE_TYPE_TRANSACTIONAL, undefined].includes(campaignType),
    },
});

const segments = defineModel({
    type: Array,
    required: true,
});

const validate = useVuelidate(
    {
        ids: {
            required: helpers.withMessage(`You haven't added any segments`, required),
            maxLength: helpers.withMessage(
                `A campaign can only contain up to ${MAX_SEGMENTS_PER_CAMPAIGN} segments.`,
                maxLength(MAX_SEGMENTS_PER_CAMPAIGN)
            ),
        },
    },
    computed(() => ({
        ids: segments.value.map((segment) => segment.id),
    }))
);

watch(
    () => props.campaignType,
    () => {
        segments.value = [];
    }
);
</script>
